/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Minimum_WarningInputs */



/**
* | output |
* | --- |
* | "You must select at least two event groups to merge" |
*
* @param {Merge_Event_Group_Minimum_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_minimum_warning = /** @type {((inputs?: Merge_Event_Group_Minimum_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Minimum_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous devez selectionner au moins deux groupes d'evenements a fusionner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie müssen mindestens zwei Ereignisgruppen auswählen, die zusammengeführt werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Devi selezionare almeno due gruppi di eventi da unire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для объединения необходимо выбрать как минимум две группы событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Debes seleccionar al menos dos grupos de eventos para fusionar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您必须选择至少两个事件组进行合并。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マージするには少なくとも 2 つのイベント グループを選択する必要があります")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपको विलय करने के लिए कम से कम दो इवेंट समूहों का चयन करना होगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você deve selecionar pelo menos dois grupos de eventos para mesclar.")
	return /** @type {LocalizedString} */ ("You must select at least two event groups to merge")
});